var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32985_130762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91797 1.68042L5.09839 6.5L9.91797 11.3196",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91797 1.68044L1.0984 6.5L5.91797 11.3196",
    stroke: "white",
    strokeOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32985_130762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(-1 0 0 1 12 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLeft);
export default __webpack_public_path__ + "static/media/double_left.85e5105b3c32e6ca6acf6b518a5a4773.svg";
export { ForwardRef as ReactComponent };